import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function OfficeIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4 6H9V8H4V6ZM4 12H9V10H4V12ZM24 5V22H0V1H13V5H24ZM11 5V3H2V20H5V18.5C5 17.6716 5.67157 17 6.5 17C7.32843 17 8 17.6716 8 18.5V20H11V5ZM22 7H13V20H16V18.5C16 17.6716 16.6716 17 17.5 17C18.3284 17 19 17.6716 19 18.5V20H22V7ZM20 10H15V12H20V10Z",
    fill: "currentColor"
  }));
}